import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { RedirectService } from '../../shared/services/redirect.service';
import { UserService } from '../../shared/services/user.service';
import { LINK_EXPIRED_PATH } from '../activate/constants';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class ChangePasswordGuard implements CanActivate {

    constructor(private userService: UserService,
                private redirectService: RedirectService,
                private authService: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
      this.authService.resetCredentials();
      let reset_password_token = route.queryParams['reset_password_token'];
      return this.userService.isValidPasswordToken(reset_password_token).take(1).map(
        () => {
          return true;
        }).catch(() => {
          this.redirectToLinkExpired();
          return Observable.of(false);
        }
      );
    }

    redirectToLinkExpired(): void {
      this.redirectService.navigateOrRedirectTo(LINK_EXPIRED_PATH);
    }
}
